/*jshint unused: false, undef:false */

'use strict';

/**
 * Adapter for Webduct Order Statuses
 *
 * @version
 * 13.0.0 MLIBJS-153 Upgrade to font-awesome v6
 * 12.4.0 #756 MLIBJS-121 Add AdapterOrderStatus into globalThis for ES6 usage
 * 9.0.0 #701 MLIBJS-75 Remove deprecated services
 * 7.3.0 #458 Refactor wdFulfillment, wdStatus (inject helpers)
 *
 * @author Deitric Jang <djang@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 *
 * @copyright (c) 2016-2023 Build Centrix
 */
var AdapterOrderStatus = function () {

    /**
     * Adapter
     *
     * This object is returned.
     *
     * @since 7.3.0
     *
     * @type {*}
     */
    var adapter = {};

    var defaultStatusIcon = 'fa-solid fa-caret-right';

    /**
     * Parse Delivery Statuses
     *
     * @since 9.0.0
     *
     * @param {Array} statuses List of order statuses to parse
     * @returns {Array} Parsed list of order statuses for display
     */
    adapter.parseDeliveryStatuses = function (statuses) {

        var results = [];

        for (var i = 0; i < statuses.length; i++) {

            var parsedStatus = {};

            var target = statuses[i];
            var index = parseInt(target.index);

            // Customisable
            parsedStatus.index = index;
            parsedStatus.label = target.label;
            parsedStatus.sortOrder = target.sort_order;
            parsedStatus.selected = true;

            // Manually Set
            parsedStatus.details = adapter.getDeliveryStatusDetails(index);

            results.push(parsedStatus);

        }

        return results;

    };

    /**
     * Parse Order Statuses
     *
     * @since 7.3.0
     * 
     * @param {Array} statuses List of order statuses to parse
     * @returns {Array} Parsed list of order statuses for display
     */
    adapter.parseStatuses = function (statuses) {

        var results = [];

        for (var i = 0; i < statuses.length; i++) {

            var parsedStatus = {};

            var target = statuses[i];
            var index = parseInt(target.index);

            // Customisable
            parsedStatus.index = index;
            parsedStatus.label = target.code;
            parsedStatus.sortOrder = target.sort;
            parsedStatus.selected = true;

            // Manually Set
            parsedStatus.details = adapter.getStatusDetails(index);

            results.push(parsedStatus);

        }

        return results;
    };

    /**
     * Get Delivery Status Details
     *
     * @since 9.0.0
     *
     * @params {number} val Delivery status index to get the details for (icon, text/background colour, remaining/total time options, etc.)
     * @returns {object} Delivery status details
     */
    adapter.getDeliveryStatusDetails = function (val) {

        var statusDetails = {};

        val = parseInt(val);

        //Based on the given value, set the Icon
        switch (val) {
            case 1: // Not Started
                statusDetails.bgColour = 'white';
                statusDetails.textColour = 'darkslategrey';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
            case 2: // Shipped / Picked Up
                statusDetails.bgColour = '#ddffdd';
                statusDetails.textColour = 'green';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
            case 3: // Cancelled
                statusDetails.bgColour = '#FF6961';
                statusDetails.textColour = 'white';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
            case 4: // Partially Shipped
                statusDetails.bgColour = 'lightblue';
                statusDetails.textColour = 'darkblue'; //'#0075B2';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
            case 5: // On Hold
                statusDetails.bgColour = 'lightgoldenrodyellow';
                statusDetails.textColour = 'darkslategrey'; //'#0075B2';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
            default: // Custom Statuses
                statusDetails.bgColour = 'lightblue';
                statusDetails.textColour = 'darkblue';
                statusDetails.icon = adapter.getDeliveryIconByStatus(val);
                break;
        }

        return statusDetails;

    };

    /**
     * Get Order Status Details
     *
     * @since 7.3.0
     * 
     * @params {number} val Order status index to get the details for (icon, text/background colour, remaining/total time options, etc.)
     * @returns {object} Order status details
     */
    adapter.getStatusDetails = function (val) {

        var statusDetails = {};

        val = parseInt(val);

        //Based on the given value, set the Icon
        switch (val) {
            case 1: //Received
                statusDetails.bgColour = 'white';
                statusDetails.textColour = 'darkslategrey';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = true;
                statusDetails.addToTotalTime = true;
                break;
            case 2: //In-Production
                statusDetails.bgColour = 'lightblue';
                statusDetails.textColour = 'darkblue'; //'#0075B2';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = true;
                statusDetails.addToTotalTime = true;
                break;
            case 3: //Ready
                statusDetails.bgColour = '#ddffdd';
                statusDetails.textColour = 'green';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = false;
                statusDetails.addToTotalTime = true;
                break;
            case 5: //Cancelled
                statusDetails.bgColour = '#FF6961';
                statusDetails.textColour = 'white';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = false;
                statusDetails.addToTotalTime = false;
                break;
            case 7: // On Hold
                statusDetails.bgColour = 'lightgoldenrodyellow';
                statusDetails.textColour = 'darkslategrey'; //'#0075B2';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = true;
                statusDetails.addToTotalTime = true;
                break;
            default: // Custom Statuses
                statusDetails.bgColour = 'lightblue';
                statusDetails.textColour = 'darkblue'; //'#0075B2';
                statusDetails.icon = adapter.getIconByStatus(val);
                statusDetails.addToRemainingTime = true;
                statusDetails.addToTotalTime = true;
                break;
        }

        return statusDetails;

    };

    /**
     * Get the Icon to be used based on Status
     *
     * @since 7.3.0
     * 
     * @param {number} status
     * @returns {string} Font Awesome css class for order status icon
     */
    adapter.getIconByStatus = function (status) {

        var result = '';

        //Based on the given value, set the Icon
        switch (status) {
            case 1: //Received
                result = 'fa-regular fa-circle';
                break;
            case 2: //In-Production
                result = 'fa-regular fa-circle-play';
                break;
            case 3: //Ready / Picked Up
                result = 'fa-regular fa-square-check';
                break;
            case 5: //Cancelled
                result = 'fa-solid fa-times';
                break;
            case 7: // On hold
                result = 'fa-regular fa-hand';
                break;
            default: // Custom Status
                result = defaultStatusIcon;
                break;
        }

        return result;

    };

    /**
     * Get the Delivery Icon to be used based on Status
     *
     * @since 7.3.0
     * 
     * @param {number} status Order status index to get delivery icon for
     * @returns {string} The Font Awesome css class for the delivery status icon
     */
    adapter.getDeliveryIconByStatus = function (status) {

        var result = '';

        //Based on the given value, set the Icon
        switch (status) {
            case 1: // Not Started
                result = 'fa-regular fa-circle';
                break;
            case 2: // Shipped / Picked Up
                result = 'fa-solid fa-truck';
                break;
            case 3: // Cancelled
                result = 'fa-solid fa-times';
                break;
            case 4: // Partially Shipped
                result = 'fa-regular fa-dot-circle';
                break;
            case 5: // On hold
                result = 'fa-regular fa-hand';
                break;
            default: // Custom Status
                result = defaultStatusIcon;
                break;
        }

        return result;

    };    
    
    return adapter;
};
globalThis.AdapterOrderStatus = AdapterOrderStatus;
// EOF
